<template>
    <div class="modal-content">
        <p class="heading-1 form-heading">
            Thanks for endorsing <br />
            <span>{{ result.name }}</span
            >!
        </p>

        <form class="endorse-form">
            <cp-text-input
                multiline
                block
                :placeholder="`I endorse ${result.name} because...`"
                id="description"
                name="endorsement-description"
                v-model="description"
            ></cp-text-input>
            <!-- user info -->
            <cp-grid align="center" justify="center" no-margin style="margin: 10px 0px">
                <cp-grid-item>
                    <cp-image class="user-image" :src="user.img" circular :alt="user.name" width="50" />
                </cp-grid-item>
                <cp-grid-item>
                    <div class="content-2">{{ user.name }}</div>
                </cp-grid-item>
            </cp-grid>
            <cp-grid class="form-buttons" align="center" justify="center">
                <cp-grid-item :span="$root.isMobile ? 10 : 7">
                    <cp-button block primary :loading="loading" :disabled="description.length == 0 || loading" @click="updateEndorsement">
                        Share my message
                    </cp-button>
                </cp-grid-item>
                <!-- dismisses modal -->
                <cp-grid-item :span="$root.isMobile ? 10 : 7">
                    <a href="#" class="no-message-btn" @click.prevent="dismissModal(false)">I don't want to post a message.</a>
                </cp-grid-item>
            </cp-grid>
        </form>
    </div>
</template>

<script>
import * as API from '../api/endorses';

export default {
    data() {
        return {
            description: '',
            loading: false,
        };
    },

    methods: {
        dismissModal() {
            this.$emit('close');
        },
        updateEndorsement() {
            this.loading = true;
            const data = {
                type: this.type,
                type_id: this.id,
                description: this.description,
                public: 1,
            };
            API.voteComment(data)
                .then((response) => {
                    this.dismissModal();
                    this.setCount('comment');
                })
                .catch((error) => {
                    console.warn(error);
                });
            this.loading = false;
        },
    },

    props: {
        result: Object,
        setCount: Function,
        type: String,
    },

    computed: {
        id() {
            return this.type == 'crowdpac' ? parseInt(this.result.objectID.match(/(\d+)/g)[0]) : this.result.id;
        },
        user() {
            return this.$root.authUser;
        },
    },

    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },

    components: {
        CpButton: require('../button').default,
        CpImage: require('../image').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        InfiniteLoading: require('vue-infinite-loading').default,
        CpButtonLink: require('../button-link').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        CpTextInput: require('../inputs/text').default,
        CpUnstyledButton: require('../unstyled-button').default,
    },
};
</script>

<style scoped>
.modal-content {
    max-width: 460px;
    padding: 40px 80px 30px;
    text-align: center;
}
@media (max-width: 768px) {
    .modal-content {
        padding: 20px 40px;
    }
}
/* transition styles */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
